module.exports = __webpack_public_path__ + "static/sport/btn-reg-active.05ee856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/btn-reg-active.png
// module id = Bgo9
// module chunks = 0